export default "__VITE_ASSET__016ed8cf__"